const sweetHomeLayers = [
    {
      id: 'PQD',
      src: '/animation_assets/sweet_home_PQD.png',
      width: '187.7px',
      height: '23.6px',
      left: '18.5%',
      top: '64.4%',
      zIndex: 20,
      alt: 'Decor & Essentials',
      role: 'text',
      group: 1 // Default group
    },
    {
      id: 'VCW',
      src: '/animation_assets/sweet_home_VCW.png',
      width: '212.2px',
      height: '69.2px',
      left: '13.7%',
      top: '38.9%',
      zIndex: 19,
      alt: 'SWEET',
      role: 'text',
      group: 0 // Default group
    },
    {
      id: 'OSP',
      src: '/animation_assets/sweet_home_OSP.png',
      width: '61.5px',
      height: '54.1px',
      left: '23.2%',
      top: '52.5%',
      zIndex: 18,
      alt: 'Aqua heart outline shape',
      role: 'text',
      group: 0 // Default group
    },
    {
      id: 'AHV',
      src: '/animation_assets/sweet_home_AHV.png',
      width: '52.7px',
      height: '78.1px',
      left: '13.0%',
      top: '50.3%',
      zIndex: 17,
      alt: 'H',
      role: 'text',
      group: 0 // Default group
    },
    {
      id: 'PHB',
      src: '/animation_assets/sweet_home_PHB.png',
      width: '102.2px',
      height: '78.1px',
      left: '35.2%',
      top: '50.3%',
      zIndex: 16,
      alt: 'ME',
      role: 'text',
      group: 0 // Default group
    },
    {
      id: 'BZQ',
      src: '/animation_assets/sweet_home_BZQ.png',
      width: '64.6px',
      height: '61.9px',
      left: '55.7%',
      top: '28.4%',
      zIndex: 15,
      alt: 'Outline of light teal heart shape',
      role: 'secondary',
      group: 0 // Default group
    },
    {
      id: 'BAQ',
      src: '/animation_assets/sweet_home_BAQ.png',
      width: '64.6px',
      height: '61.9px',
      left: '55.7%',
      top: '28.4%',
      zIndex: 15,
      alt: 'Light teal outlined heart shape',
      role: 'secondary',
      group: 0 // Default group
    },
    {
      id: 'BNQ',
      src: '/animation_assets/sweet_home_BNQ.png',
      width: '64.6px',
      height: '61.9px',
      left: '55.7%',
      top: '28.4%',
      zIndex: 15,
      alt: 'Outline of teal heart shape',
      role: 'secondary',
      group: 0 // Default group
    },
    {
      id: 'ESS',
      src: '/animation_assets/sweet_home_ESS.png',
      width: '144.5px',
      height: '144.5px',
      left: '57.6%',
      top: '40.5%',
      zIndex: 13,
      alt: 'Minimalist house outline icon',
      role: 'primary',
      group: 0 ,
      orientation: 'front',
    },
    {
      id: 'RRM',
      src: '/animation_assets/sweet_home_RRM.png',
      width: '512.2px',
      height: '512.2px',
      left: '0.0%',
      top: '-0.0%',
      zIndex: 11,
      alt: 'Background',
      role: 'background',
      group: 0 // Default group
    }
  ];

export default sweetHomeLayers;